export const YANDEX_METRIKA_ID = 109447690;

export type MetrikaGoal =
  | 'quick_search_submit'
  | 'quick_search_result'
  | 'quick_search_error'
  | 'login_click'
  | 'upload_click'
  | 'seo_page_click';

type MetrikaParamValue = string | number | boolean | null | undefined;
type MetrikaParams = Record<string, MetrikaParamValue>;

declare global {
  interface Window {
    ym?: (counterId: number, method: string, ...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

const getDefaultParams = (): MetrikaParams => {
  if (typeof window === 'undefined') {
    return {};
  }

  return {
    path: window.location.pathname,
  };
};

export const trackGoal = (goal: MetrikaGoal, params: MetrikaParams = {}) => {
  if (typeof window === 'undefined' || typeof window.ym !== 'function') {
    return;
  }

  window.ym(YANDEX_METRIKA_ID, 'reachGoal', goal, {
    ...getDefaultParams(),
    ...params,
  });
};

export const trackPageView = (url?: string) => {
  if (typeof window === 'undefined' || typeof window.ym !== 'function') {
    return;
  }

  window.ym(YANDEX_METRIKA_ID, 'hit', url || window.location.href, {
    title: document.title,
    referer: document.referrer,
  });
};
